import axios from 'axios';
import { tokenManager } from '../utils/tokenManager';

// Use the same base URL as rag-service for organization endpoints
const RAG_API_URL = window.env.REACT_APP_RAG_API_URL || "http://localhost:8002/api/v1";

// Create axios instance for organization API
const organizationApiInstance = axios.create({
  baseURL: RAG_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Setup secure interceptors using centralized token manager
tokenManager.setupInterceptors(organizationApiInstance);

// Organization API service
export const organizationApi = {
  // Get all organizations for the current user
  getOrganizations: (config = {}) => {
    return organizationApiInstance.get('/organizations/', config);
  },

  // Get a specific organization by ID
  getOrganization: (orgId, config = {}) => {
    return organizationApiInstance.get(`/organizations/${orgId}`, config);
  },

  // Create a new organization
  createOrganization: (organizationData) => {
    return organizationApiInstance.post('/organizations/', organizationData);
  },

  // Update an organization
  updateOrganization: (orgId, organizationData) => {
    return organizationApiInstance.put(`/organizations/${orgId}`, organizationData);
  },

  // Delete an organization
  deleteOrganization: (orgId) => {
    return organizationApiInstance.delete(`/organizations/${orgId}`);
  },

  // Get organization members
  getOrganizationMembers: (orgId, config = {}) => {
    return organizationApiInstance.get(`/organizations/${orgId}/members`, config);
  },

  // Add a member to an organization
  addOrganizationMember: (orgId, memberData) => {
    return organizationApiInstance.post(`/organizations/${orgId}/members`, memberData);
  },

  // Update organization member role
  updateOrganizationMember: (orgId, userId, memberData) => {
    return organizationApiInstance.put(`/organizations/${orgId}/members/${userId}`, memberData);
  },

  // Remove a member from an organization
  removeOrganizationMember: (orgId, userId) => {
    return organizationApiInstance.delete(`/organizations/${orgId}/members/${userId}`);
  },

  // Get organization statistics
  getOrganizationStats: (orgId) => {
    return organizationApiInstance.get(`/organizations/${orgId}/stats`);
  },

  // Leave an organization (remove current user)
  leaveOrganization: (orgId) => {
    return organizationApiInstance.delete(`/organizations/${orgId}/members/me`);
  }
};
